import { PropsWithChildren, ReactNode } from "react"
import cn from "classnames"

import { CLIENT_AUTHORIZATION_PLACE } from "../../Default/common/constant"

import styles from "./style.module.scss"

import { Img } from "ui-kit/components-branded"

interface Props {
    headline: string
    secondary: ReactNode
    place?: CLIENT_AUTHORIZATION_PLACE
    className?: string
}

export const ErrorPage = ({
    headline,
    secondary,
    place,
    className,
    children,
}: PropsWithChildren<Props>) => {
    return (
        <section
            className={cn(
                styles.container,
                {
                    [styles.isMain]: place === CLIENT_AUTHORIZATION_PLACE.MAIN,
                },
                className
            )}
        >
            <div>
                <div className={styles.headline}>{headline}</div>
                <div className={styles.text}>{secondary}</div>
            </div>
            <div className={styles.footer}>
                <Img className={styles.illustration} src="error-illustration.svg" />
                {children}
            </div>
        </section>
    )
}
